// GatewayBanner.jsx
import React from 'react';
import { 
  ArrowRight, 
  Building2, 
  Factory, 
  Microscope, 
  Users, 
  Rocket,
  CheckCircle,
  Globe,
  Zap,
  Shield,
  Sparkles
} from 'lucide-react';
import './Facilitieshomepage.css';
import Navbar from './Navbar';
import FacilityInfo from './FacilityInfo';
import  CTA from './CTA';
import Footer from'./Footer';
import Facilities from '../../pages/Facilities.jsx';

const GatewayBanner = () => {
  const stats = [
    { value: "50+", label: "Facilities" },
    { value: "2,500+", label: "Innovators" },
    { value: "150+", label: "Machines" },
    { value: "12", label: "Centres" }
  ];

  return (
    <>
    <Navbar/>
    <section className="gateway-banner">
      {/* Background Image with Overlay */}
      <div className="gateway-background">
        <img
          src="https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=1600&q=80"
          alt="Modern manufacturing facility"
          className="gateway-bg-image"
          loading="eager"
        />
        <div className="gateway-overlay"></div>
        <div className="gateway-glow-1"></div>
        <div className="gateway-glow-2"></div>
      </div>

      {/* Content */}
      <div className="gateway-content">
        <div className="gateway-container">
          {/* Left Side - Text Content */}
          <div className="gateway-left">
            {/* Badge */}
            <div className="gateway-badge">
              <Sparkles size={14} className="gateway-badge-icon" />
              <span>Innovation Gateway</span>
            </div>

            {/* Heading */}
            <h1 className="gateway-heading">
              <span className="gateway-heading-line1">Turn your facility into</span>
              <span className="gateway-heading-line2">a gateway for innovation.</span>
            </h1>

            {/* Description */}
            <p className="gateway-description">
              APIC ProtoHub connects manufacturing facilities, innovation centres, 
              R&D labs, universities and technology providers with innovators, 
              startups, and industry experts.
            </p>

            {/* Features Grid */}
            <div className="gateway-features-grid">
              <div className="gateway-feature-card">
                <div className="gateway-feature-icon">
                  <Factory size={18} />
                </div>
                <div>
                  <p className="gateway-feature-title">Manufacturing</p>
                  <p className="gateway-feature-desc">Facilities & Production</p>
                </div>
              </div>

              <div className="gateway-feature-card">
                <div className="gateway-feature-icon">
                  <Microscope size={18} />
                </div>
                <div>
                  <p className="gateway-feature-title">R&D Labs</p>
                  <p className="gateway-feature-desc">Research & Development</p>
                </div>
              </div>

              <div className="gateway-feature-card">
                <div className="gateway-feature-icon">
                  <Building2 size={18} />
                </div>
                <div>
                  <p className="gateway-feature-title">Innovation Centres</p>
                  <p className="gateway-feature-desc">Hubs & Ecosystems</p>
                </div>
              </div>

              <div className="gateway-feature-card">
                <div className="gateway-feature-icon">
                  <Users size={18} />
                </div>
                <div>
                  <p className="gateway-feature-title">Universities</p>
                  <p className="gateway-feature-desc">Academia & Research</p>
                </div>
              </div>
            </div>

            {/* CTA */}
            <button className="gateway-cta-btn">
              <Rocket size={18} />
              <span>Start Your Innovation Journey</span>
              <ArrowRight size={18} className="gateway-cta-arrow" />
            </button>

            {/* Stats */}
            {/* <div className="gateway-stats">
              {stats.map((stat, index) => (
                <React.Fragment key={index}>
                  <div className="gateway-stat-item">
                    <p className="gateway-stat-value">{stat.value}</p>
                    <p className="gateway-stat-label">{stat.label}</p>
                  </div>
                  {index < stats.length - 1 && (
                    <div className="gateway-stat-divider"></div>
                  )}
                </React.Fragment>
              ))}
            </div> */}
          </div>

          {/* Right Side - Image Card */}
          <div className="gateway-right">
            <div className="gateway-image-card">
              <div className="gateway-image-wrapper">
                <img
                  src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
                  alt="Innovation facility with advanced machinery"
                  className="gateway-right-image"
                  loading="lazy"
                />
                
                {/* Floating Cards */}
                <div className="gateway-float-card card-1">
                  <div className="gateway-float-icon">
                    <Zap size={16} />
                  </div>
                  <div>
                    <p className="gateway-float-title">Real-time</p>
                    <p className="gateway-float-desc">Monitoring</p>
                  </div>
                </div>

                <div className="gateway-float-card card-2">
                  <div className="gateway-float-icon">
                    <Shield size={16} />
                  </div>
                  <div>
                    <p className="gateway-float-title">Secure</p>
                    <p className="gateway-float-desc">Platform</p>
                  </div>
                </div>

                <div className="gateway-float-card card-3">
                  <div className="gateway-float-icon">
                    <Globe size={16} />
                  </div>
                  <div>
                    <p className="gateway-float-title">Global</p>
                    <p className="gateway-float-desc">Network</p>
                  </div>
                </div>

                {/* Trust Badge */}
                <div className="gateway-trust-badge">
                  <div className="gateway-trust-avatars">
                    <div className="gt-avatar">A</div>
                    <div className="gt-avatar">B</div>
                    <div className="gt-avatar">C</div>
                    <div className="gt-avatar">D</div>
                    <div className="gt-avatar-more">+2k</div>
                  </div>
                  <div>
                    <p className="gateway-trust-text">Join 2,000+ innovators</p>
                    <p className="gateway-trust-sub">Building the future</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <FacilityInfo/>
    <Facilities/>
      <CTA />
     <Footer />
    </>
  );
};

export default GatewayBanner;